import { Link } from 'react-router'

export default function LandingPricing() {
	return (
		<section className="px-6 py-32">
			<div className="mx-auto max-w-6xl">
				<div className="mb-16 text-center">
					<h2 className="mb-4 text-5xl font-extrabold tracking-tight text-foreground md:text-6xl">
						Simple <span className="bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">Pricing</span>
					</h2>
					<p className="mx-auto max-w-2xl text-xl text-base-content/80 md:text-2xl">
						Choose the plan that works for you
					</p>
				</div>
				<div className="grid gap-8 md:grid-cols-3 md:items-stretch">
					{/* Free Plan */}
					<div className="group relative flex flex-col rounded-3xl border border-foreground/20 bg-background/50 p-8 backdrop-blur-sm transition-all duration-300 hover:border-indigo-400/50 hover:shadow-2xl hover:shadow-indigo-500/20">
						<div className="mb-4">
							<h3 className="text-2xl font-bold text-foreground md:text-3xl">Free</h3>
							<div className="mt-4 flex items-baseline gap-2">
								<span className="text-5xl font-extrabold text-foreground">$0</span>
							</div>
						</div>
						<ul className="mb-8 flex-1 space-y-4 text-base-content/80">
							<li className="flex items-start gap-3">
								<span className="mt-1 text-indigo-400">✓</span>
								<span>1 free processed episode</span>
							</li>
							<li className="flex items-start gap-3">
								<span className="mt-1 text-indigo-400">✓</span>
								<span>Up to 30 minutes</span>
							</li>
							<li className="flex items-start gap-3">
								<span className="mt-1 text-indigo-400">✓</span>
								<span>Full-quality download</span>
							</li>
							<li className="flex items-start gap-3">
								<span className="mt-1 text-indigo-400">✓</span>
								<span>No credit card required</span>
							</li>
						</ul>
						<Link
							to="/editor"
							className="block w-full rounded-full border-2 border-foreground/30 px-6 py-3 text-center font-bold text-foreground backdrop-blur-sm transition-all duration-300 hover:scale-105 hover:border-indigo-400"
						>
							Try Podly
						</Link>
					</div>

					{/* Creator Plan */}
					<div className="group relative flex flex-col rounded-3xl border-2 border-indigo-400/50 bg-gradient-to-br from-indigo-500/20 to-purple-500/20 p-8 backdrop-blur-sm transition-all duration-300 hover:scale-105 hover:border-indigo-400 hover:shadow-2xl hover:shadow-indigo-500/30">
						<div className="absolute -top-4 left-1/2 -translate-x-1/2 rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 px-4 py-1 text-sm font-bold whitespace-nowrap text-white shadow-lg">
							Most Popular
						</div>
						<div className="mb-4">
							<h3 className="text-2xl font-bold text-foreground md:text-3xl">
								Creator
							</h3>
							<p className="mt-1 text-sm text-base-content/60">
								For podcasters
							</p>
							<div className="mt-4 flex items-baseline gap-2">
								<span className="text-5xl font-extrabold text-foreground">$5</span>
								<span className="text-lg text-base-content/70">/month</span>
							</div>
							<p className="mt-2 text-sm font-semibold text-indigo-400">
								Limited-time price — increasing to $9/mo soon
							</p>
						</div>
						<ul className="mb-8 flex-1 space-y-4 text-base-content/80">
							<li className="flex items-start gap-3">
								<span className="mt-1 text-indigo-400">✓</span>
								<span>Unlimited episode processing</span>
							</li>
							<li className="flex items-start gap-3">
								<span className="mt-1 text-indigo-400">✓</span>
								<span>Processing history</span>
							</li>
							<li className="flex items-start gap-3">
								<span className="mt-1 text-indigo-400">✓</span>
								<span>Saved projects</span>
							</li>
							<li className="flex items-start gap-3">
								<span className="mt-1 text-indigo-400">✓</span>
								<span>Priority processing</span>
							</li>
							<li className="flex items-start gap-3">
								<span className="mt-1 text-indigo-400">✓</span>
								<span>Future editing features</span>
							</li>
						</ul>
						<Link
							to="/signup"
							className="block w-full rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 px-6 py-3 text-center font-bold text-white shadow-lg shadow-indigo-500/50 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-indigo-500/60"
						>
							Get Started
						</Link>
					</div>

					{/* Pro Plan — not yet available */}
					<div className="relative flex flex-col rounded-3xl border border-foreground/20 bg-background/50 p-8 opacity-60 backdrop-blur-sm">
						<div className="mb-4">
							<div className="mb-2 inline-block rounded-full bg-foreground/10 px-3 py-1 text-sm font-bold text-base-content/50">
								Coming Soon
							</div>
							<h3 className="text-2xl font-bold text-base-content/60 md:text-3xl">
								Pro
							</h3>
							<p className="mt-1 text-sm text-base-content/50">
								For serious creators
							</p>
							<div className="mt-4 flex items-baseline gap-2">
								<span className="text-5xl font-extrabold text-base-content/60">
									$19
								</span>
								<span className="text-lg text-base-content/50">/month</span>
							</div>
						</div>
						<ul className="mb-8 flex-1 space-y-4 text-base-content/60">
							<li className="flex items-start gap-3">
								<span className="mt-1 text-base-content/40">✓</span>
								<span>Up to 15 hours of processing per month</span>
							</li>
							<li className="flex items-start gap-3">
								<span className="mt-1 text-base-content/40">✓</span>
								<span>Priority processing</span>
							</li>
							<li className="flex items-start gap-3">
								<span className="mt-1 text-base-content/40">✓</span>
								<span>More storage</span>
							</li>
							<li className="flex items-start gap-3">
								<span className="mt-1 text-base-content/40">✓</span>
								<span>Multiple projects</span>
							</li>
							<li className="flex items-start gap-3">
								<span className="mt-1 text-base-content/40">✓</span>
								<span>Future publishing features</span>
							</li>
							<li className="flex items-start gap-3">
								<span className="mt-1 text-base-content/40">✓</span>
								<span>Future video capabilities</span>
							</li>
						</ul>
						<button
							disabled
							className="block w-full cursor-not-allowed rounded-full border-2 border-foreground/30 bg-background/50 px-6 py-3 text-center font-bold text-base-content/50 backdrop-blur-sm"
						>
							Coming Soon
						</button>
					</div>
				</div>
			</div>
		</section>
	)
}
